// Pure helpers (no Leaflet/React) so they run under plain `node --test`.
export const HAZARD_COLORS = {
  cyclone: '#E11D2E',
  flood: '#0369A1',
  earthquake: '#B45309',
};

export const HAZARD_ICON_SIZE_PX = 48;

function escapeHtmlAttr(value) {
  return String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;');
}

/**
 * Injects sizing and a11y attributes into the opening <svg> tag of a hazard glyph.
 * Without a `label` the glyph is decorative (its text sits next to it).
 */
export function hazardMarkup(rawSvg, { size = HAZARD_ICON_SIZE_PX, label } = {}) {
  const px = Number.isFinite(size) ? Math.min(96, Math.max(8, size)) : HAZARD_ICON_SIZE_PX;
  const a11y = label
    ? `role="img" aria-label="${escapeHtmlAttr(label)}"`
    : 'aria-hidden="true" focusable="false"';
  return String(rawSvg)
    .trim()
    .replace(/<svg\b/, () => `<svg width="${px}" height="${px}" ${a11y}`);
}
